/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup";
import SmallPopup from "../../../../components/_utils/CommonSmallPopup";
import PrimaryStepper from "../../../../components/_utils/CommonSteppers/PrimaryStepper";
import SVGComponent from "../../../../components/_utils/SVGComponent";
import RemitAccountStepName from "../../../../components/Accounts/RemitAccount/RemitAccountCreate/RemitAccoountStepName";
import RemitAccountStepConfirm from "../../../../components/Accounts/RemitAccount/RemitAccountCreate/RemitAccountStepConfirm";
import {
  remitterAccountCreate,
  remitterAccountViewAll,
  resetCreateRemitter,
} from "../../../../redux/features/accounts/remitterAccount/remitterAccount";
import {
  GlobalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider";

const RemitterAccountCreate = () => {
  const scrollIt = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [labels, setLabels] = useState([]);
  const [exitFlow, setExitFlow] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [direction, setDirection] = useState(null);
  const [labelpopup, setLabelpopup] = useState(false);
  const [isDuplicate, setIsDuplicate] = useState(null);
  const [isNextDisabled, setIsNextDisabled] = useState(true);
  const [createDisabled, setCreateDisabled] = useState(false);
  const [removeClassName, setRemoveClassName] = useState(true);
  const [openSimilarPopup, setOpenSimilarPopup] = useState(false);
  const [duplicateLoading, setDuplicateLoading] = useState(false);
  const [labelPopupLoading, setLabelPopupLoading] = useState(false);
  const [selectedLabelsCreate, setSelectedLabelsCreate] = useState([]);
  const [hasAnimatedDuplicate, setHasAnimatedDuplicate] = useState(false);
  const [isDuplicateConfirmed, setIsDuplicateConfirmed] = useState(false);
  const [accountPayLoad, setAccountPayLoad] = useState({
    remitterAccountName: "",
    labels: [],
  });

  const { remitterAccountViewAllLoading, remitterAccountAvailableLabels } =
    useSelector((state) => state.remitterAccount);

  const animationClass =
    direction === "next" ? "animate-slide-next" : "animate-slide-prev";

  const steps = ["Account name and labels", "Confirm and create"];

  const commonStepperConfig = {
    previousEnableBgColor: "var(--primary-nav-act)",
    previousDisableBgColor: "var(--text-disabled)",
    previousEnableTextColor: "var(--text-primary)",
    previousHoverOption: "white",
    nextEnableBgColor: "var(--text-primary)",
    nextDisableBgColor: "var(--text-disabled)",
    nextEnableTextColor: "var(--primary-bg)",
    nextDisableTextColor: "var(--text-primary)",
    nextHoverOption: "black",
  };

  const dataArray = steps.map((stepLabel, index) => {
    const isLastStep = index === steps.length - 1;
    const isRemitterAccountLoading = isLastStep && createDisabled;
    return {
      ...commonStepperConfig,
      previousText: index === 0 ? "Cancel" : "Previous",
      previousIsDisabled: isRemitterAccountLoading,
      nextText: isLastStep ? "Create" : "Next",
      nextLoaderNeeded: isLastStep,
      nextIsLoading: isRemitterAccountLoading,
      nextIsEnabled: isLastStep ? !createDisabled : !isNextDisabled,
      nextEnableBgColor: isLastStep
        ? "var(--positive-act)"
        : "var(--text-primary)",
      nextDisableBgColor: isLastStep
        ? "var(--positive-act)"
        : "var(--text-disabled)",
      nextEnableTextColor: isLastStep
        ? "var(--text-primary)"
        : "var(--primary-bg)",
      nextDisableTextColor: isLastStep
        ? "var(--text-primary)"
        : "var(--text-primary)",
      stepperText: stepLabel,
    };
  });

  const { services, isLoading } = useSelector((state) => state.refreshToken);

  const handleCreateAccount = async () => {
    try {
      setCreateDisabled(true);

      const data = await dispatch(
        remitterAccountCreate({
          name: accountPayLoad.remitterAccountName,
          labels: accountPayLoad.labels,
        }),
      ).unwrap();

      const remitterAccountId = data?.remitter_accounts?.[0]?.id;

      if (remitterAccountId) {
        navigate(
          `/remitter_account_dashboard/create_remitter_account/success/${remitterAccountId}`,
        );
      }
    } catch (error) {
      console.error("Create account failed", error);
      navigate("/remitter_account_dashboard/create_remitter_account/failed", {
        state: error,
      });
    } finally {
      setCreateDisabled(false);
    }
  };

  const checkDuplicateAccount = async () => {
    const name = accountPayLoad?.remitterAccountName?.trim();

    if (!name) return false;

    try {
      setDuplicateLoading(true);

      const response = await dispatch(
        remitterAccountViewAll({
          search_string: name,
        }),
      );

      const duplicateFound =
        response?.payload?.remitter_accounts?.length >
        GlobalConfiguration.lengthCheckZero;

      setIsDuplicate(duplicateFound);
      if (duplicateFound) {
        setHasAnimatedDuplicate(false);
        // CommonToast({
        //   text: "Account already exists with the same name.",
        //   icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        //   variant: "var(--error)",
        // });
      }
      return duplicateFound;
    } catch (error) {
      console.error(error);
      return false;
    } finally {
      setDuplicateLoading(false);
    }
  };

  const handleNext = async () => {
    const isLastStep =
      activeStep === steps.length - GlobalConfiguration.lengthCheckOne;

    setSelectedLabelsCreate(selectedLabelsCreate || []);
    if (isLastStep) {
      handleCreateAccount();
      return;
    }

    // if (activeStep === 0) {
    //   const duplicateFound = await checkDuplicateAccount();

    //   if (duplicateFound) {
    //     setOpenSimilarPopup(false);
    //     return;
    //   }
    // }

    setActiveStep((prev) => prev + GlobalConfiguration.lengthCheckOne);
    setDirection("next");

    setRemoveClassName(false);

    setTimeout(() => {
      setRemoveClassName(true);
    }, GlobalConfiguration.delayTime);
  };

  const handleBack = () => {
    if (activeStep === GlobalConfiguration.lengthCheckZero) {
      const hasEnteredData =
        accountPayLoad?.remitterAccountName?.trim()?.length >
          GlobalConfiguration.lengthCheckZero ||
        accountPayLoad?.labels?.length > GlobalConfiguration.lengthCheckZero;

      if (!hasEnteredData) {
        navigate(GlobalConfiguration.lengthCheckNegativeOne);
        return;
      } else {
        setExitFlow(true);
        return;
      }
    }
    setActiveStep(
      (prevActiveStep) => prevActiveStep - GlobalConfiguration.lengthCheckOne,
    );
    setDirection("previous");
    setRemoveClassName(false);
    setTimeout(() => {
      setRemoveClassName(true);
    }, GlobalConfiguration.delayTime);
  };

  const accountHome = () => {
    const hasEnteredData =
      accountPayLoad?.remitterAccountName?.trim()?.length >
        GlobalConfiguration.lengthCheckZero ||
      accountPayLoad?.labels?.length > GlobalConfiguration.lengthCheckZero;

    if (hasEnteredData) {
      setExitFlow(true);
      return;
    }
    navigate(GlobalConfiguration.lengthCheckNegativeOne);
  };

  const renderCreateAccount = () => {
    switch (activeStep) {
      case 0:
        return (
          <RemitAccountStepName
            accountPayLoad={accountPayLoad}
            setAccountPayLoad={setAccountPayLoad}
            labelpopup={labelpopup}
            setLabelpopup={setLabelpopup}
            setIsDuplicate={setIsDuplicate}
            openSimilarPopup={openSimilarPopup}
            setOpenSimilarPopup={setOpenSimilarPopup}
            duplicateLoading={duplicateLoading}
            setDuplicateLoading={setDuplicateLoading}
            checkDuplicateAccount={checkDuplicateAccount}
            isDuplicate={isDuplicate}
            isRemitterAccountLoading={remitterAccountViewAllLoading}
            isDuplicateConfirmed={isDuplicateConfirmed}
            setIsDuplicateConfirmed={setIsDuplicateConfirmed}
            hasAnimatedDuplicate={hasAnimatedDuplicate}
            setHasAnimatedDuplicate={setHasAnimatedDuplicate}
          />
        );
      case 1:
        return (
          <RemitAccountStepConfirm
            accountPayLoad={accountPayLoad}
            setAccountPayLoad={setAccountPayLoad}
          />
        );
      default:
        return null;
    }
  };

  const handleClose = (finalLabels) => {
    setLabelpopup(false);

    if (finalLabels === undefined || finalLabels === null) return;

    setAccountPayLoad((accountPayLoad) => ({
      ...accountPayLoad,
      labels: finalLabels,
    }));

    setSelectedLabelsCreate(finalLabels);
  };

  useEffect(() => {
    if (!isLoading && services != null) {
      if (services?.includes("REUAccount") || services?.includes("Admin")) {
      } else {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "REUAccount" },
        });
      }
    }
  }, [services, isLoading]);

  useEffect(() => {
    let isValid = false;
    if (activeStep === GlobalConfiguration.lengthCheckZero) {
      const name = accountPayLoad?.remitterAccountName || "";
      const nameValid =
        name.trim().length >= GlobalConfiguration.lengthCheckThree;

      if (!nameValid || isDuplicate === null) {
        isValid = false;
      } else if (isDuplicate === true) {
        isValid = isDuplicateConfirmed;
      } else {
        isValid = true;
      }
    } else {
      isValid = true;
    }
    setIsNextDisabled(!isValid);
  }, [accountPayLoad, activeStep, isDuplicate, isDuplicateConfirmed]);

  useEffect(() => {
    if (remitterAccountAvailableLabels?.length) {
      setLabels(remitterAccountAvailableLabels);
    }
  }, [remitterAccountAvailableLabels]);

  useEffect(() => {
    return () => {
      dispatch(resetCreateRemitter());
    };
  }, [dispatch]);

  useEffect(() => {
    const labels = sessionStorage.getItem("remitterAccountAvailableLabels");

    if (!labels) {
      dispatch(
        remitterAccountViewAll({
          page_no: GlobalConfiguration.lengthCheckOne,
          page_item_count: PaginationConfiguration.paginationSmall,
        }),
      );
    }
  }, []);

  return (
    <div className="w-width-full flex flex-col items-center h-full-height bg-primary-bg">
      {exitFlow && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop bg-opacity-dark-opacity justify-center z-z-index-modal">
          <SmallPopup
            headerTitle={"Confirm leaving this page?"}
            headerFontWeight="semibold"
            headerFontColor="negative-act"
            textSize="font-md"
            subtext="Leaving this page will exit from the current flow."
            btnOneText="Stay"
            btnOneBtnType="button"
            btnOneEnabledBgColor="transparent"
            btnOneHandleFunction={() => setExitFlow(false)}
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Leave"
            btnTwoBtnType="button"
            btnTwoHandleFunction={() =>
              navigate(GlobalConfiguration.lengthCheckNegativeOne)
            }
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoHoverOption="black"
          />
        </div>
      )}
      {labelpopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <CommonAssignLabelPopup
            headerTitle="Assign&#47;unassign labels:"
            headersubtext={
              "These will be used to generate statistics for the associated account."
            }
            closehandleFunction={handleClose}
            closeisDisabled={false}
            labels={labels}
            setLabels={setLabels}
            isLabelPopupOpen={labelpopup}
            selectedLabelsCreate={selectedLabelsCreate}
            setSelectedLabelsCreate={setSelectedLabelsCreate}
            loading={labelPopupLoading}
            setLoading={setLabelPopupLoading}
            type="create"
          />
        </div>
      )}
      <div className="w-width-full Qlg:bg-transparent bg-primary-nav rounded-b-border-radius-md">
        <div className="h-navbar-height hidden Qsmd:block"></div>
        <div className="h-[calc(var(--navbar-breadcrumb-height)-var(--navbar-height))] mb-margin-sm mt-margin-xs Qsmd:my-margin-base"></div>
      </div>

      <div className="flex justify-center items-end !bottom-bottom-base rounded-t-border-radius-md Qlg:bg-transparent bg-primary-nav rounded-b-border-radius-md w-screen fixed Qsmd:relative Qsmd:top-top-base left-left-base z-z-index-header flex-shrink-0 h-[var(--padding-bottom-unassign-cat)]">
        <PrimaryStepper
          activeStep={activeStep}
          handleForwardAction={handleNext}
          handleBackwardAction={handleBack}
          dataArray={dataArray}
        />
      </div>

      <div
        className="flex items-center w-width-full py-padding-sm px-padding-md h-mobile-create-header fixed left-left-base top-top-base z-z-index-header Qsmd:hidden"
        onClick={accountHome}
      >
        <SVGComponent
          color="var(--text-primary)"
          height="var(--icon-sm)"
          width="var(--icon-sm)"
          url={ICONS?.ARROW_LEFT_WHITE}
          alt="Icon"
        />
        <div className="flex flex-col pl-padding-md gap-gap-xs">
          <p className="text-font-md font-sans text-text-primary">
            Remitter Account
          </p>
          <p className="text-xs font-sans text-text-primary">
            {steps[activeStep]}
          </p>
        </div>
      </div>

      <>
        <div
          className="overflow-x-hidden overflow-y-auto h-full flex flex-col items-center relative w-width-full"
          ref={scrollIt}
        >
          <div
            className={`w-width-full  Qsmd:pt-padding-md Qsmd:pb-padding-md pt-padding-base max-w-tab-width-normal mx-auto ${
              activeStep === 0 && direction === "next"
                ? ""
                : removeClassName === true
                  ? ""
                  : animationClass
            }`}
          >
            {renderCreateAccount()}
          </div>
        </div>
      </>

      <div className="h-stepper-moble-height flex-shrink-0 w-width-full Qsmd:hidden block"></div>
    </div>
  );
};

export default RemitterAccountCreate;
